// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ──────────────────────────────────────────────────────────
   CommandPalette — app-chrome overlay
   Tokens: src/styles/tokens.css
   ────────────────────────────────────────────────────────── */

.cmd-palette__scrim {
  position: fixed;
  inset: 0;
  background: rgba(10, 22, 51, 0.32);
  z-index: var(--z-modal, 1600);
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.cmd-palette__panel {
  position: relative;
  z-index: calc(var(--z-modal, 1600) + 1);
  margin-top: 12vh;
  width: 100%;
  max-width: 520px;
  background: var(--bg-alt);
  border: 1px solid var(--border);
  box-shadow: var(--shadow);
  border-radius: 2px;
  overflow: hidden;
  font-family: var(--sans);
}

/* Input row */
.cmd-palette__input-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-bottom: 1px solid var(--border);
}

.cmd-palette__search-icon {
  flex-shrink: 0;
  color: var(--text-muted);
}

.cmd-palette__input {
  flex: 1;
  border: none;
  background: transparent;
  outline: none;
  font-family: var(--sans);
  font-size: var(--fs-note);
  color: var(--text);
  caret-color: var(--signal);
}

.cmd-palette__input::placeholder {
  color: var(--text-muted);
}

.cmd-palette__trigger-hint {
  flex-shrink: 0;
  font-family: var(--mono);
  font-size: var(--fs-sm);
  color: var(--text-muted);
  background: var(--bg);
  border: 1px solid var(--border);
  border-radius: 2px;
  padding: 1px 5px;
}

/* Empty state */
.cmd-palette__empty {
  padding: 24px 16px;
  text-align: center;
  font-size: var(--fs-ui);
  color: var(--text-muted);
}

/* List */
.cmd-palette__list {
  list-style: none;
  margin: 0;
  padding: 6px 0;
  max-height: 360px;
  overflow-y: auto;
}

.cmd-palette__list ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

/* Group */
.cmd-palette__group {
  margin-bottom: 2px;
}

.cmd-palette__group-label {
  display: block;
  padding: 6px 14px 2px;
  font-size: var(--fs-micro);
  font-family: var(--mono);
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--text-muted);
}

/* Item */
.cmd-palette__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 14px;
  cursor: pointer;
  font-size: var(--fs-ui);
  color: var(--text);
  transition: background var(--dur-1, 120ms) ease;
}

.cmd-palette__item:hover,
.cmd-palette__item--highlighted {
  background: var(--signal-soft);
}

.cmd-palette__item-left {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.cmd-palette__item-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  color: var(--text-secondary);
  font-size: var(--fs-note);
}

.cmd-palette__item-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Shortcut */
.cmd-palette__item-shortcut {
  display: flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
  margin-left: 12px;
}

.cmd-palette__item-shortcut kbd {
  font-family: var(--mono);
  font-size: var(--fs-micro);
  color: var(--text-secondary);
  border: 1px solid var(--border);
  border-radius: 2px;
  padding: 1px 5px;
  background: var(--bg);
  line-height: 1.4;
}
`, "",{"version":3,"sources":["webpack://./src/shared/CommandPalette/CommandPalette.css"],"names":[],"mappings":"AAAA;;;+DAG+D;;AAE/D;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,+BAA+B;EAC/B,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,0BAA0B;EAC1B,wBAAwB;EACxB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA,SAAS;AACT;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,4BAA4B;EAC5B,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB","sourcesContent":["/* ──────────────────────────────────────────────────────────\n   CommandPalette — app-chrome overlay\n   Tokens: src/styles/tokens.css\n   ────────────────────────────────────────────────────────── */\n\n.cmd-palette__scrim {\n  position: fixed;\n  inset: 0;\n  background: rgba(10, 22, 51, 0.32);\n  z-index: var(--z-modal, 1600);\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n.cmd-palette__panel {\n  position: relative;\n  z-index: calc(var(--z-modal, 1600) + 1);\n  margin-top: 12vh;\n  width: 100%;\n  max-width: 520px;\n  background: var(--bg-alt);\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow);\n  border-radius: 2px;\n  overflow: hidden;\n  font-family: var(--sans);\n}\n\n/* Input row */\n.cmd-palette__input-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 14px;\n  border-bottom: 1px solid var(--border);\n}\n\n.cmd-palette__search-icon {\n  flex-shrink: 0;\n  color: var(--text-muted);\n}\n\n.cmd-palette__input {\n  flex: 1;\n  border: none;\n  background: transparent;\n  outline: none;\n  font-family: var(--sans);\n  font-size: var(--fs-note);\n  color: var(--text);\n  caret-color: var(--signal);\n}\n\n.cmd-palette__input::placeholder {\n  color: var(--text-muted);\n}\n\n.cmd-palette__trigger-hint {\n  flex-shrink: 0;\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n  background: var(--bg);\n  border: 1px solid var(--border);\n  border-radius: 2px;\n  padding: 1px 5px;\n}\n\n/* Empty state */\n.cmd-palette__empty {\n  padding: 24px 16px;\n  text-align: center;\n  font-size: var(--fs-ui);\n  color: var(--text-muted);\n}\n\n/* List */\n.cmd-palette__list {\n  list-style: none;\n  margin: 0;\n  padding: 6px 0;\n  max-height: 360px;\n  overflow-y: auto;\n}\n\n.cmd-palette__list ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n/* Group */\n.cmd-palette__group {\n  margin-bottom: 2px;\n}\n\n.cmd-palette__group-label {\n  display: block;\n  padding: 6px 14px 2px;\n  font-size: var(--fs-micro);\n  font-family: var(--mono);\n  font-weight: 600;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n\n/* Item */\n.cmd-palette__item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 7px 14px;\n  cursor: pointer;\n  font-size: var(--fs-ui);\n  color: var(--text);\n  transition: background var(--dur-1, 120ms) ease;\n}\n\n.cmd-palette__item:hover,\n.cmd-palette__item--highlighted {\n  background: var(--signal-soft);\n}\n\n.cmd-palette__item-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.cmd-palette__item-icon {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  color: var(--text-secondary);\n  font-size: var(--fs-note);\n}\n\n.cmd-palette__item-label {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Shortcut */\n.cmd-palette__item-shortcut {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  flex-shrink: 0;\n  margin-left: 12px;\n}\n\n.cmd-palette__item-shortcut kbd {\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  color: var(--text-secondary);\n  border: 1px solid var(--border);\n  border-radius: 2px;\n  padding: 1px 5px;\n  background: var(--bg);\n  line-height: 1.4;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
